module.exports = __webpack_public_path__ + "img/info.b5f5a88.webp";